module.exports = __webpack_public_path__ + "media/app/assets/specializations/shaman/elemental-d8df149e47c139645d41a79c19f25cfa.png";